import React, { useState, useEffect } from 'react';
import Hero from '../../components/Hero/Hero';
import MovieCarousel from '../../components/MovieCarousel/MovieCarousel';
import LatestSection from '../../components/LatestSection/LatestSection';
import { getPopularMovies, getNewMovies, getTrendingMovies, getFeaturedMovies } from '../../utils/database';
import './HomePage.css';

const HomePage = () => {
  const [popularMovies, setPopularMovies] = useState([]);
  const [newMovies, setNewMovies] = useState([]);
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [featuredMovie, setFeaturedMovie] = useState(null);
  const [latestMovies, setLatestMovies] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadMovies();
  }, []);

  const loadMovies = () => {
    setPopularMovies(getPopularMovies());
    setNewMovies(getNewMovies());
    setTrendingMovies(getTrendingMovies());
    
    const featured = getFeaturedMovies();
    if (featured.length > 0) {
      setFeaturedMovie(featured[0]);
    } else if (newMovies.length > 0) {
      setFeaturedMovie(newMovies[0]);
    }
    
    setLatestMovies(getNewMovies().slice(0, 2));
  };

  return (
    <div className="home-page">
      <Hero featuredMovie={featuredMovie} />
      
      <div className="home-page__content">
        {popularMovies.length > 0 && (
          <MovieCarousel 
            title="Popular"
            movies={popularMovies}
            viewAllLink="/popular"
          />
        )}
        
        {featuredMovie && latestMovies.length > 0 && (
          <LatestSection 
            featuredMovie={featuredMovie}
            sideMovies={latestMovies}
          />
        )}
        
        {trendingMovies.length > 0 && (
          <MovieCarousel 
            title="Trending Now"
            movies={trendingMovies}
            viewAllLink="/trending"
          />
        )}
        
        {newMovies.length > 0 && (
          <MovieCarousel 
            title="New Releases"
            movies={newMovies}
            viewAllLink="/new"
          />
        )}
      </div>
    </div>
  );
};

export default HomePage;